import React from 'react';
import './WHMCS.css';

const WHMCSTemplate = () => {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <>
      <div className="seo-header">
        <h1>قالب WHMCS | طراحی قالب اختصاصی و حرفه‌ای | افراسل</h1>
        <p>طراحی و توسعه قالب‌های اختصاصی WHMCS با ظاهری زیبا، ریسپانسیو و بهینه شده برای سئو.</p>
        <meta name="description" content="طراحی قالب اختصاصی WHMCS با ظاهری حرفه‌ای و ریسپانسیو." />
      </div>

      <section className="whmcs-hero">
        <div className="whmcs-hero-bg"></div>
        <div className="wrap">
          <div className="whmcs-hero-content">
            <div className="whmcs-badge">
              <span className="pulse-dot"></span>
              🎨 قالب WHMCS
            </div>
            <h1 className="whmcs-hero-title">
              قالب <em>WHMCS</em>
            </h1>
            <p className="whmcs-hero-desc">
              قالب WHMCS نقش مهمی در جذب مشتری و افزایش فروش دارد. ما در افراسل قالب‌های اختصاصی WHMCS را با ظاهری زیبا، ریسپانسیو (سازگار با موبایل) و بهینه شده برای سئو طراحی می‌کنیم. همچنین امکان شخصی‌سازی قالب‌های موجود و تغییر ظاهر WHMCS بر اساس برند شما وجود دارد.
            </p>
            <div className="whmcs-hero-stats">
              <div className="stat-item">
                <span className="stat-number">زیبا</span>
                <span className="stat-label">ریسپانسیو</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">۱۰۰+</span>
                <span className="stat-label">پروژه موفق</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">۲۴/۷</span>
                <span className="stat-label">پشتیبانی</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="whmcs-cta">
        <div className="wrap">
          <div className="cta-box">
            <h2 className="cta-title">
              قالب <em>WHMCS</em> را با افراسل تجربه کنید
            </h2>
            <p className="cta-desc">
              با قالب‌های اختصاصی WHMCS، ظاهری حرفه‌ای و زیبا به سیستم خود ببخشید.
            </p>
            <div className="cta-btns">
              <button className="btn-lg primary" onClick={() => scrollTo('contact')}>مشاوره رایگان</button>
              <button className="btn-lg ghost" onClick={() => scrollTo('contact')}>درخواست خدمات</button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default WHMCSTemplate;
